import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default class ServerErrorException extends Error {
    constructor(message?: string) {
        const messageText = message ?? "Something went wrong, try again later...";

        super(messageText);

        DiagnosticsStore.collectEventLog("error", messageText);
    }
}
